import { createSlice } from "@reduxjs/toolkit";
import { SCREENS } from "../components/Marketing/constant";

const initialState = {
    currentScreen: SCREENS?.CMO_OVERVIEW || "CMO_OVERVIEW",
    productStage: null,
    marketingGoal: null,
    adBudget: null,
    selectedPlanId: null,
    websiteUrl: "",
    manualDescription: "",
    aiCmoId: null,
    marketingPlan: null,
    adConcepts: [],
    generatedScript: null,
    selectedConceptId: null,
    cmoPlans: [],
    brandDetails: {
        name: "",
        industry: "",
        audience: "",
        tone: "",
        colors: ["#F97316", "#000000", "#FFFFFF"],
        logo: null
    },
    showChatPanel: false
};

const marketingSlice = createSlice({
    name: "marketing",
    initialState,
    reducers: {
        updateMarketingState: (state, action) => {
            // Allows updating one or many properties at once
            return { ...state, ...action.payload };
        },
        resetMarketingState: () => initialState,
    }
});

export const { updateMarketingState, resetMarketingState } = marketingSlice.actions;
export default marketingSlice.reducer;
